export default "__VITE_ASSET__Bcf3wkde__"